import PropTypes from 'prop-types';
import React, { Component } from 'react';

import HeaderMenuSearch from '../../components/HeaderMenuSearch';

class HeaderSearch extends Component {
  render() {
    const { onSearchCloseClick, className } = this.props;

    return (
      <div className={className}>
        <HeaderMenuSearch
          onSearchCloseClick={onSearchCloseClick}
          {...this.props}
          {...this.state}
        />
      </div>
    );
  }
}

HeaderSearch.propTypes = {
  /*
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * Function to trigger closing of search.
   */
  onSearchCloseClick: PropTypes.func,
};

HeaderSearch.defaultProps = {
  className: '',
  onSearchCloseClick: () => {},
};

export default HeaderSearch;
